import script from "./SubmenuList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubmenuList.vue?vue&type=script&lang=ts&setup=true"

import "./SubmenuList.vue?vue&type=style&index=0&id=344ac616&lang=scss"

const __exports__ = script;

export default __exports__